var Select = "Select";
var Expand = "Expand";
var enUS = {
	Select: Select,
	"Select all": "Select all",
	Expand: Expand
};

export { Expand, Select, enUS as default };
